import { render, staticRenderFns } from "./ResourcesCategory.vue?vue&type=template&id=cb5ed6e8&scoped=true"
import script from "./ResourcesCategory.vue?vue&type=script&lang=js"
export * from "./ResourcesCategory.vue?vue&type=script&lang=js"
import style0 from "./ResourcesCategory.vue?vue&type=style&index=0&id=cb5ed6e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5ed6e8",
  null
  
)

export default component.exports